import Marquee from "react-fast-marquee";

const logos = [
  { name: "Indigo", url: "https://vingrace.com/wp-content/uploads/2023/06/indigo-airline.jpg" },
  { name: "RBI", url: "https://vingrace.com/wp-content/uploads/2023/06/reserve-bank-of-india-150x120-1.jpg" },
  { name: "Sheraton", url: "https://vingrace.com/wp-content/uploads/2023/06/sheraton-hotel-resorts.jpg" },
  { name: "Tata Westside", url: "https://vingrace.com/wp-content/uploads/2023/06/tata-westside.jpg" },
  { name: "Marriott", url: "https://vingrace.com/wp-content/uploads/2023/06/marriott-hotel-resots.jpg" },
  { name: "DLF", url: "https://vingrace.com/wp-content/uploads/2023/06/dlf-building-mall-india.jpg" },
  { name: "Shroff Eye", url: "https://vingrace.com/wp-content/uploads/2023/06/shroff-eye-center.jpg" },
  { name: "ICWA", url: "https://vingrace.com/wp-content/uploads/2023/06/Indian-council-of-world-affairs.jpg" },
];

export default function ClientLogos() {
  return (
    <section data-testid="client-logos-section" className="py-10 bg-white border-y border-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-6">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-stone-400 text-center">
          Trusted by India's Leading Organizations
        </p>
      </div>
      <Marquee speed={30} gradient gradientColor="#ffffff" gradientWidth={60} pauseOnHover>
        {logos.map((logo) => (
          <div key={logo.name} className="mx-8 flex items-center">
            <img
              src={logo.url}
              alt={logo.name}
              className="h-10 sm:h-12 w-auto object-contain logo-grayscale"
              loading="lazy"
            />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
